import BranchListContainer from './BranchListContainer';

export default BranchListContainer;
